import styled from "styled-components";

// Styled Severe Flag Level Display
export const SevereFlagLevel = styled.span`
	background-color: #f8dcdb;
	color: #344054;
	border-width: 0;
	border-radius: 4px;
	height: 28px;
	width: 70px;
	text-wrap: nowrap;
	display: flex;
	justify-content: center;
	align-items: center;
`;

// Styled Severe Flag Level Display
export const MajorFlagLevel = styled(SevereFlagLevel)`
	background-color: #faefde;
`;

// Styled Severe Flag Level Display
export const MinorFlagLevel = styled(SevereFlagLevel)`
	background-color: #dbe7e1;
`;

export const NoneFlagLevel = styled(SevereFlagLevel)`
	background-color: #e6e6e6;
`;
